import { render, staticRenderFns } from "./BoxSectionTemplate.vue?vue&type=template&id=40e2b564&"
import script from "./BoxSectionTemplate.vue?vue&type=script&lang=js&"
export * from "./BoxSectionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BoxSectionTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports